import LogoIcon from "@/nav-localized/assets/logo.svg?react";
import { stylesText } from "./styles";
import { BUITheme } from "@blofin/blofin-ui";
import { FC } from "react";

const Logo: FC<{ theme: BUITheme }> = ({ theme }) => {
  return (
    <LogoIcon
      className={`w-[80px] ${stylesText({
        mode: theme
      })}`}
    />
  );
};

export default Logo;
